import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Tab} from '../tab.model';
import {TabStyles} from '../tab-styles';
import {TabContainerData} from '../tab-container-data';

@Component({
  selector: 'spb-square-tabs',
  templateUrl: './square-tabs.component.html',
})
export class SquareTabsComponent implements OnInit {
  @Input() tabContainerData: TabContainerData[];
  @Input() tabsToShow: Tab[];
  @Input() tabStyles: TabStyles;
  @Output() onTabSelection: EventEmitter<any> = new EventEmitter();
  @HostBinding('class.spb-square-tabs') hostBaseClass = true;

  constructor() {
  }

  ngOnInit() {
  }
}
